import * as React from "react";
import { forwardRef } from "react";
const SvgStatus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ColorStatus-gn" }, /* @__PURE__ */ React.createElement("rect", { id: "Contour", opacity: 0.5, x: 1.5, y: 1.5, width: 13, height: 13, stroke: "currentColor", strokeWidth: 3, strokeLinejoin: "bevel" }), /* @__PURE__ */ React.createElement("rect", { id: "Surface", x: 3, y: 3, width: 10, height: 10, fill: "currentColor" })));
const ForwardRef = forwardRef(SvgStatus);
export { ForwardRef as ReactComponent };
